import {listener, onReady} from "../../../../../modules/vegas/js/util";

function changeCommentAreaPosition(delivery) {
	let commentArea = document.querySelector('#form-cart .comment-area');
	let paymentArea = document.querySelector('#form-cart .payment-area');

	if ([2, 3].indexOf(delivery) !== -1) {
		paymentArea.before(commentArea);
	} else {
		paymentArea.after(commentArea);
	}
}

listener('keydown change', '#form-cart [name=delivery_id]', (el, e) => {
	changeCommentAreaPosition(parseInt(el.value));
});

onReady(() => {
	let delivery = document.querySelector('#form-cart [name=delivery_id]');
	if (delivery) {
		changeCommentAreaPosition(parseInt(delivery.value));
	}
});
